import type { SVGProps } from "react";

export function ChartUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3 4v16h18" />
      <path d="M7 15v3" />
      <path d="M11 13v5" />
      <path d="M15 10v8" />
      <path d="M6 16l4-4 4 3 5-8" />
    </svg>
  );
}
